import {Provider} from "./components/ui/provider";
import {useContext, useEffect, useState} from "react";
import "./App.css";

import {
    TodoListContextProvider,
    TodoListContext,
} from "./TodoListContextProvider";
import {DarkModeContext, DarkModeContextProvider} from "./DarkModeContext";
import {LoginContext, LoginContextProvider} from "./LoginContextProvider";
import {Todo} from "./api";
import {Button, createSystem, defaultBaseConfig, defineConfig, Input} from "@chakra-ui/react";
import {Switch} from "./components/ui/switch";

function TodoList() {
    const {list, remove, updateTodo, remove_all} = useContext(TodoListContext);
    if (list.length === 0) {
        return <p>No Todos available</p>;
    } else {
        const rows = list.map((element) => (
            <tr key={element.id} className={element.isDone ? "todo--done" : ""}>
                <td>
                    <Button  variant="subtle" rounded={"lg"} onClick={() => remove(element.id)}>X</Button>
                </td>
                <td><TodoContentEdit todo={element}/></td>
                <td>
                    <button onClick={() => updateTodo(element.id, null, !element.isDone)}>
                        {element.isDone ? "Done!" : "In Progress"}
                    </button>
                </td>
            </tr>
        ));

        return (
            <>
                <table>
                    <tbody>{rows}</tbody>
                    <tfoot>
                    <tr>
                        <td></td>
                        <td>
                            <Button className="clear-all"
                                    onClick={() => {
                                remove_all();
                            }} variant="solid">Clear todos
                            </Button>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </>
        );
    }
}

function TodoContentEdit({todo}: { todo: Todo }) {
    const {updateTodo} = useContext(TodoListContext);
    const [content, setContent] = useState(todo.content);
    const [edit, setEdit] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        updateTodo(todo.id, content, todo.isDone);
        setEdit(false);
    };

    return (
        <div>
            {edit ? (
                <form method="POST" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                    />
                    <button type="submit">Save</button>
                </form>
            ) : (
                <span onClick={() => setEdit(true)}>{content}</span>
            )}
        </div>
    )
}


function DarkMode() {
    const {isDarkMode, setDarkMode} = useContext(DarkModeContext);
    return (
        <div className="hs">
            <p>Dark Mode   </p>
            <Switch checked={isDarkMode} onCheckedChange={(e) => setDarkMode(e.checked)} />
        </div>
    );
}

function Login() {
    const [showLoginForm, setShowLoginForm] = useState(false);
    const {logout, isLoggedIn} = useContext(LoginContext);

    const handleLoginAction = () => {
        setShowLoginForm((prev) => !prev);
    };

    const handleLogoutAction = () => {
        logout();
    };

    return !isLoggedIn ? (
        <>
            <Button className="button" onClick={handleLoginAction} variant="solid">Log In</Button>
            {showLoginForm && <LoginForm setShowLoginForm={setShowLoginForm}/>}
        </>
    ) : (
        <Button className="button" onClick={handleLogoutAction} variant="subtle">Log Out</Button>
    );
}

function LoginForm({setShowLoginForm}) {
    const {login} = useContext(LoginContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        login(email, password);
        setShowLoginForm(false);
    };

    return (
        <div className="loginForm">
            <form method="post" onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    required
                    onChange={(e) => {
                        setEmail(e.target.value);
                    }}
                />
                <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    required
                    onChange={(e) => {
                        setPassword(e.target.value);
                    }}
                />
                <button type="submit">Submit</button>
            </form>
        </div>
    );
}

function DarkModeWrapper({children}) {
    const {isDarkMode} = useContext(DarkModeContext);
    return (
        <div id="app-root" className={isDarkMode ? "darkmode" : ""}>
            {children}
        </div>
    );
}

function AddTodo() {
    const {addTodo} = useContext(TodoListContext);
    const [value, setValue] = useState("");

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                addTodo(value);
                setValue("");
            }}
            onInvalid={(e) => e.preventDefault()}
            className="hs"
        >
            <Input placeholder="Add Todo"
                   value={value}
                   className="addTodo"
                   type="text"
                   onChange={(e) => setValue(e.target.value)}
                   required variant="subtle"
            />
            <Button type="submit" className="addButton" variant="solid">+</Button>
        </form>
    );
}

export default function App() {
    const [, setDarkMode] = useState(false);

    useEffect(() => {
        const savedDarkMode = localStorage.getItem("darkMode");
        if (savedDarkMode !== null) {
            setDarkMode(JSON.parse(savedDarkMode));
        }
    }, []);

    return (
        <Provider>
            <LoginContextProvider>
                <TodoListContextProvider>
                    <DarkModeContextProvider>
                        <DarkModeWrapper>
                            <nav>
                                <Login/>
                                <DarkMode/>
                            </nav>
                            <div className="todoAdd">
                                <AddTodo/>
                            </div>
                            <TodoList/>
                        </DarkModeWrapper>
                    </DarkModeContextProvider>
                </TodoListContextProvider>
            </LoginContextProvider>
        </Provider>
    );
}

